module.exports = __webpack_public_path__ + "static/media/terms.e756334d.svg";